export default __webpack_public_path__ + "static/media/Reuse_share.2a5ed396.svg";